import { useCallback, useState } from "react";

import { useGetUserInformation } from "../../../features/users";

import { useGetMessages } from "../../../lib/queries/queriesAndMutations";
import Loader from "../../shared/Loader";
import Pagination from "../../shared/Pagination";
import MessageCard from "./MessageCard";

const MessagesPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const { data: user } = useGetUserInformation();
  const userId = user?.id;

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const {
    data: messages,
    isPending,
    isRefetching,
  } = useGetMessages({
    userId,
    currentPage,
    pageSize,
  });

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex-center min-h-[400px] ">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {messages?.data.count > 0 ? (
        <div className="w-full ">
          <div className="w-full flex flex-col items-end  p-2 rounded-v-lg gap-1 ">
            {messages?.data.items.map((item, index) => (
              <MessageCard message={item?.message} />
            ))}
          </div>

          <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
            <Pagination
              onPageChange={onPageChange}
              totalCount={messages?.data?.count || 0}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-primary-40"
            />
          </div>
        </div>
      ) : (
        <div className="flex flex-col min-h-[300px]  m-auto justify-center items-center gap-6">
          <div className="bg-neutral-10 flex flex-col items-center p-6 rounded-md">
            <img src="/images/folder-empty.svg" alt="" className="max-w-[40px] max-h-[40px]" />
            <p> پیامی وجود ندارد!</p>
          </div>
        </div>
      )}
    </>
  );
};

export default MessagesPage;
